import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DrawerState } from '../../../core/models/enum';
import { CompetitionFormInitialValues } from '../../../core/models/InitialValues';
import { CompetitionDetailVm } from '../../../utils/api';
import { RouteParams } from '../../../core/models/RouteHelper';
import CompetitionForm from './CompetitionForm';

interface OwnProps {
    competition?: CompetitionDetailVm;
    initialValues?: CompetitionFormInitialValues;
    handleClose: (drawerMode: DrawerState, id?: string) => void;
    refreshAfterSave: () => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(CompetitionForm);
